import {
  allocatedToOptions,
  countyDropDownOptions,
  enquiryRatingOptions,
  pipelineStatusOptions,
} from './EnquiryFormFieldsDropDownData';

// ============================================================================
// CONTACT INFORMATION SECTION
// (Client feedback: Home Address / Home Eir Code / County moved in here from
// the old "Forest & Company General Information" section. "Completed By"
// also moved in here. Enquiry Type moved OUT of here — it's now one of the
// 3 top-level inputs alongside Show / Transaction Type, see EnquiryFormModal.jsx)
// ============================================================================
export const generalSectionIp = [
  {
    name: 'enquirerName',
    label: 'Enquirer Name',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: '',
    required: true,
  },
  {
    name: 'phoneNumber',
    label: 'Phone Number',
    typeOfInp: 'phone',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: '',
    // Client feedback: phone number is no longer compulsory, and should
    // accept international numbers (not just mobile / IE+GB).
    required: false,
  },
  {
    name: 'email',
    label: 'Email',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: '',
    required: false,
  },

  // Client feedback: Enquiry Type moved to the top row of the form
  // (alongside Show / Transaction Type). Left here commented for reference
  // of the old field config in case the width/label needs to be reused.
  // {
  //   name: 'enquiryType',
  //   label: 'Enquiry Type',
  //   typeOfInp: 'select',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },

  // ---- Moved in from the old "Forest & Company General Information" section ----
  {
    name: 'homeAddress',
    label: 'Home Address',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: '',
    required: false,
  },
  {
    name: 'homeEirCode',
    label: 'Home Eir Code',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: '',
    required: false,
  },
  {
    name: 'county',
    label: 'County',
    typeOfInp: 'select',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: '',
    required: false,
  },
  {
    // TODO: this should be auto-filled with the currently logged-in user
    // once we know how auth/user context is exposed in this app (Redux,
    // Context, a hook like useAuth(), etc). For now it's a disabled
    // placeholder field — see EnquiryFormModal.jsx.
    name: 'completedBy',
    label: 'Completed by',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    helperText: 'Who put this enquiry up',
    required: false,
  },
];

export const enquiryOptions = ['Private', 'Forestry Company', 'Sawmill', 'Other'];
export const generalSectionDropDownData = {
  enquiryType: enquiryOptions,
  county: countyDropDownOptions,
};

// ============================================================================
// LEGACY: "Forest & Company General Information" section fields.
// Client feedback: this whole section is commented out for now (fields have
// been redistributed into Contact Information and Forest Information).
// Kept here, untouched, in case anything still needs to be pulled from it.
// ============================================================================
// export const compannyAndForestIpFields = [
//   {
//     name: 'sizeInHectares',
//     label: 'Size In Hectares',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'forestersName',
//     label: 'Foresters Name',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'companyName',
//     label: 'Company Name',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'completedBy',
//     label: 'Completed by',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'enquiryOriginatedFrom',
//     label: 'Enquiry Originated From',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'homeAddress',
//     label: 'Home Address',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'homeEirCode',
//     label: 'Home Eir Code',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'county',
//     label: 'County',
//     typeOfInp: 'select',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'dropPinlocationForForest',
//     label: 'Google drop pin for Forest location',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: 'Paste the link from Google maps here',
//     required: false,
//   },
//   {
//     name: 'longitudeForForestEntrance',
//     label: 'Longitude For Forest Entrance',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     name: 'latitudeForForestEntrance',
//     label: 'Latitude  For Forest Entrance',
//     typeOfInp: 'input',
//     textFieldType: 'text',
//     isTextArea: false,
//     width: 4,
//     helperText: '',
//     required: false,
//   },
//   {
//     label: 'Is Forest Address Same As Home',
//     name: 'isForestAddressSameAsHome',
//     typeOfInp: 'checkbox',
//     textFieldType: 'checkbox',
//     isTextArea: false,
//     width: 3,
//     helperText: 'Tick if Forest at same Address',
//     required: false,
//   },
// ];
export const companyAndForestSectionDropDownData = {
  county: countyDropDownOptions,
};

// ============================================================================
// FOREST INFORMATION SECTION
// Client feedback: trimmed down to Forest Description / Age / Yield only.
// "Managed by" removed. Forest Townland / Forest Address / Forest Eircode /
// Forest County removed (replaced by Site Address / Site Eir Code / County,
// which are rendered explicitly in EnquiryFormModal.jsx rather than via this
// array, since they sit alongside the forester/company toggle and the
// Google Maps drop-pin field).
// ============================================================================
export const forestInfoIpFields = [
  {
    name: 'forestDescription',
    label: 'Forest Description',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 8,
    helperText: '',
    required: false,
  },
  // {
  //   name: 'forestAge',
  //   label: 'What age is it?',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
  // {
  //   name: 'yieldClass',
  //   label: 'What is the yield class',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
  // Client feedback: remove "Managed by" — replaced by the
  // "Is Forest managed by a Forester/Company?" toggle in the modal.
  // {
  //   name: 'managedBy',
  //   label: 'Managed by',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
  // Client feedback: remove Forest Townland / Forest Address / Forest
  // Eircode / Forest County — replaced by Site Address / Site Eir Code /
  // County (see explicit fields in EnquiryFormModal.jsx Forest Info section).
  // {
  //   name: 'forestTownland',
  //   label: 'Forest Townland',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
  // {
  //   name: 'forestAddress',
  //   label: 'Forest Address',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
  // {
  //   name: 'forestEircode',
  //   label: 'Forest Eircode',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
  // {
  //   name: 'forestCounty',
  //   label: 'Forest County',
  //   typeOfInp: 'select',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 4,
  //   helperText: '',
  //   required: false,
  // },
];
export const forestInfoSectionDropDownData = {
  forestCounty: countyDropDownOptions,
  // Used by the new "Site County" field in the Forest Information section.
  siteCounty: countyDropDownOptions,
};

// ============================================================================
// JOB TYPE SECTION
// Client feedback: trimmed to just the job-type checkboxes. Species
// (Sitka .. Other) pulled out into their own "Species" section below —
// a forest can have multiple species, so this stays multi-select checkboxes.
// ============================================================================
export const jobTypeIpFields = [
  { label: '1st Thinning', name: 'firstThinning' },
  { label: '2nd Thinning', name: 'secondThinning' },
  { label: '3rd Thinning', name: 'thirdThinning' },
  { label: 'Clearfell', name: 'clearfell' },
  { label: 'Site Clearance', name: 'siteClearance' },
  { label: 'Hedgerow', name: 'hedgerow' },
  // Species moved to speciesIpFields below.
  // { label: 'Sitka', name: 'sitka' },
  // { label: 'Norway', name: 'norway' },
  // { label: 'Pine', name: 'pine' },
  // { label: 'Larch', name: 'larch' },
  // { label: 'Douglas', name: 'douglas' },
  // { label: 'Softwood', name: 'softwood' },
  // { label: 'Ash', name: 'ash' },
  // { label: 'Sycamore', name: 'sycamore' },
  // { label: 'Alder', name: 'alder' },
  // { label: 'Hardwood', name: 'hardwood' },
  // { label: 'Other', name: 'other' },
];

// New: Species section (multi-select — a forest can contain multiple species).
export const speciesIpFields = [
  { label: 'Sitka Spruce', name: 'sitka' },
  { label: 'Norway', name: 'norway' },
  { label: 'Pine', name: 'pine' },
  { label: 'Larch', name: 'larch' },
  { label: 'Douglas', name: 'douglas' },
  { label: 'Softwood', name: 'softwood' },
  { label: 'Ash', name: 'ash' },
  { label: 'Sycamore', name: 'sycamore' },
  { label: 'Alder', name: 'alder' },
  { label: 'Hardwood', name: 'hardwood' },
  { label: 'Other', name: 'other' },
];

// ============================================================================
// INTERNAL NOTES SECTION (renamed from "Follow Up Section")
// Client feedback: remove Teams Link text field, replace with a file
// attachment placeholder (rendered explicitly in the modal, not array-driven).
// "Additional Information shared with Grower" moved out into the new
// Brochure & Grower Communication section (rendered near the top of the form).
// ============================================================================
export const followUpSectionIpFields = [
  {
    name: 'followUpDetails',
    label: 'Follow up details (internal use only)',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
    helperText: '',
    required: false,
  },
  // Client feedback: remove Teams Link field — replaced by a file-attachment
  // placeholder rendered explicitly in EnquiryFormModal.jsx.
  // {
  //   name: 'teamLink',
  //   label: 'Teams Link (internal use only)',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 12,
  //   helperText: '',
  //   required: false,
  // },
  // Client feedback: moved to the new "Brochure & Grower Communication"
  // section near the top of the form.
  // {
  //   name: 'additionalInfoFromGrower',
  //   label: 'Additional Information shared with Grower',
  //   typeOfInp: 'input',
  //   textFieldType: 'text',
  //   isTextArea: true,
  //   width: 12,
  //   helperText: '',
  //   required: false,
  // },
  {
    name: 'followUpDate',
    label: 'Follow up Date',
    typeOfInp: 'input',
    textFieldType: 'date',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'allocatedTo',
    label: 'Allocated to',
    typeOfInp: 'select',
    textFieldType: 'date',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'pipelineStatus',
    label: 'Pipeline Status',
    typeOfInp: 'select',
    textFieldType: 'date',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'enquiryRating',
    label: 'Enquiry Rating',
    typeOfInp: 'select',
    textFieldType: 'date',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
];
export const followUpSectionDropDownData = {
  allocatedTo: allocatedToOptions,
  pipelineStatus: pipelineStatusOptions,
  enquiryRating: enquiryRatingOptions,
};

export const officeUseSectionIpFields = [
  {
    name: 'dateTimeToSend',
    label: 'Date & Time to send',
    typeOfInp: 'input',
    textFieldType: 'date',
    isTextArea: false,
    width: 3,
    helperText: 'Date',
    required: false,
  },
  {
    name: 'view',
    label: 'View',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'dateSent',
    label: 'Date Sent',
    typeOfInp: 'input',
    textFieldType: 'date',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'homeEircode',
    label: 'Home Eircode',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'action',
    label: 'Action',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 3,
    helperText: '',
    required: false,
  },
  {
    name: 'oldEnquirerTitle',
    label: 'Old Enquirer Title',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 3,
    helperText: 'Title',
    required: false,
  },
  {
    name: 'oldEnquirerFullName',
    label: 'Old Enquirer Name',
    typeOfInp: 'input',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
    helperText: 'Full Name',
    required: false,
  },
];